import React, { useEffect } from "react";

import Slider from "react-slick";
import { Container } from "reactstrap";
// import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";


import "../../styles/hero-slider.css";

const HeroSlider = () => {

  useEffect(()=>{
    AOS.init({ duration: 800 })
  },[])

  const settings = {
    fade: true,
    speed: 4000,
    autoplaySpeed: 4000,
    infinite: true,
    autoplay: true,
    lazyload: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
  };
  return (
    <Slider {...settings} className="hero__slider mt-3" data-aos="fade-up">
      <div className="slider__item slider__item-01 mt0">
        <Container>
          <div className="slider__content ">
            <h4 className="text-light mb-3">For Easy Travels</h4>
            <h1 className="text-light mb-4">Book a ride and get there now!</h1>

            <button className="btn reserve__btn mt-4">
              <a href="#hero_form">Book Now</a>
            </button>
          </div>
        </Container>
      </div>

      <div className="slider__item slider__item-02 mt0">
        <Container>
          <div className="slider__content ">
            <h4 className="text-light mb-3">For Hotel Room Booking!</h4>
            <h1 className="text-light mb-4">Call us and book a room!</h1>

            <button className="btn reserve__btn mt-4">
              <a href="#hero_form">Reserve Now</a>
            </button>
          </div>
        </Container>
      </div>

      <div className="slider__item slider__item-03 mt0">
        <Container>
          <div className="slider__content ">
            <h4 className="text-light mb-3">For Information About Tour/Safari</h4>
            <h1 className="text-light mb-4">Call Us or Chat With Us!</h1>

            <button className="btn reserve__btn mt-4">
              <a href="#hero_form">Call Now</a>
            </button>
          </div>
        </Container>
      </div>
    </Slider>
  );
};

export default HeroSlider;
